import { Typography, Box } from '@mui/material';
import React from 'react';
import Helper from '../../../utility/helper';

const ParticiapntList = React.memo((props) => {
    const { item, subActivitiy, endUser, participant } = props;

    const userInfo = Helper.getStorage('userInfo');
    //console.log('participantList')


    return (
        <>
            {
                subActivitiy ?
                    item.subActivityParticipants.map((vals, index) => {
                        const splitSubAct = vals.participant.replace(',', '').split(' ')
                        if (vals.userType === 'Participant' || vals.userType === 'Event Staff') {
                            if (item.subActivityParticipants.length > 4) {
                                return (
                                    <React.Fragment key={`pSubActivity_${index}`} >
                                        <Typography
                                            fontSize={11}
                                            key={vals.userID}
                                            title={vals.participant}
                                            component="span"
                                            sx={{
                                                marginRight: '2px',
                                                cursor: 'pointer',
                                                fontWeight: endUser ? userInfo.userID === vals.userID ? '900' : null : null,
                                            }}>
                                            {(splitSubAct[2] !== undefined ? splitSubAct[2].charAt(0).toUpperCase() : '') + splitSubAct[1].charAt(0).toUpperCase() + '' + splitSubAct[0].charAt(0).toUpperCase() + '' + (item.subActivityParticipants.length !== (index + 1) ? ', ' : '')}
                                        </Typography>
                                    </React.Fragment>
                                )
                            } else {
                                return (
                                    <React.Fragment key={`pSubActivity_${index}`}>
                                        <Typography
                                            fontSize={11}
                                            key={vals.userID}
                                            component="span"
                                            title={vals.participant}
                                            sx={{
                                                marginRight: '2px',
                                                cursor: 'pointer',
                                                fontWeight: endUser ? userInfo.userID === vals.userID ? '900' : null : null,
                                            }}>
                                            {vals.participant.replace(',', ' ') + (item.subActivityParticipants.length !== (index + 1) ? ', ' : '')}
                                        </Typography>
                                    </React.Fragment>
                                )
                            }
                        }
                    }) :

                    item.actualData.participants.map((vals, index) => {
                        if (vals.userType === 'Participant' || (
                            vals.userType === 'Event Staff' && (vals.roleName === 'Event Staff' || vals.roleName === "Event Admin")
                        )) {
                            // inc++
                            const splitD = vals.participant.replace(',', '').split(' ')
                            if (item.actualData.participants.length > 4) {
                                return (
                                    <React.Fragment key={`pSubActivity_${index}`}>
                                        <Typography
                                            fontSize={11}
                                            key={vals.userID}
                                            component="span"
                                            title={vals.participant}
                                            sx={{
                                                marginRight: '2px',
                                                cursor: 'pointer',
                                                fontWeight: endUser ? userInfo.userID === vals.userID ? '900' : null : null,
                                            }}>
                                            {(splitD[2] !== undefined ? splitD[2].charAt(0).toUpperCase() : '') + splitD[1].charAt(0).toUpperCase() + '' + splitD[0].charAt(0).toUpperCase() + '' + (item.actualData.participants.length !== (index + 1) ? ', ' : '')}

                                        </Typography>
                                    </React.Fragment>
                                )
                            } else {
                                return (
                                    <React.Fragment key={`pSubActivity_${index}`}>
                                        <Typography
                                            fontSize={11}
                                            key={vals.userID}
                                            component="span"
                                            title={vals.participant}
                                            sx={{
                                                marginRight: '2px',
                                                cursor: 'pointer',
                                                fontWeight: endUser ? userInfo.userID === vals.userID ? '900' : null : null,
                                            }}>
                                            {vals.participant.replace(',', ' ') + (item.actualData.participants.length !== (index + 1) ? ', ' : '')}
                                        </Typography>
                                    </React.Fragment>
                                )
                            }
                        }
                    })
            }
        </>
    );

});

export default ParticiapntList